import { render } from "./RegisterModel.vue?vue&type=template&id=0f47cfb6&scoped=true"
import script from "./RegisterModel.vue?vue&type=script&lang=js"
export * from "./RegisterModel.vue?vue&type=script&lang=js"

import "./RegisterModel.vue?vue&type=style&index=0&id=0f47cfb6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f47cfb6"]])

export default __exports__